module.exports = __webpack_public_path__ + "static/photo5-df961599e90f022b54b8a22d35e5b4ef.png";